export enum PageTypeEnum {
  ADD = 'Add',
  EDIT = 'Edit',
  DUPLICATE = 'Duplicate',
  OVERVIEW = 'Overview'
}
